module.exports = __webpack_public_path__ + "img/image_2024_11_04T08_31_28_265Z.af221302.png";